import { useState } from "react";
import "./styles.css";
import "../nav-button.css";
import { Thermometer } from "../Thermometer";

interface VraagType {
    id?: string;
    vraagstelling: string;
    toelichting?: string;
    antwoord?: number;
}

interface ResultaatProps {
    vragen: VraagType[];
    onTerugNaarVragen: () => void;
}

export const Resultaat = ({ vragen, onTerugNaarVragen }: ResultaatProps) => {
    const [toonVragen, setToonVragen] = useState(false);

    const scoreLabels: Record<number, string> = {
        0: "Nooit of zelden",
        1: "Soms",
        2: "Vaak",
        3: "Erg vaak"
    };

    const v1a = ((vragen[0].antwoord!) >= 2 || (vragen[2].antwoord!) >= 2) ? 1 : 0;
    const v1b = ((vragen[4].antwoord!) >= 2) ? 1 : 0;
    const v1c = ((vragen[6].antwoord!) >= 2) ? 1 : 0;
    const v1d = ((vragen[9].antwoord!) >= 2 || (vragen[10].antwoord!) >= 2) ? 1 : 0;
    const v1e = ((vragen[13].antwoord!) >= 2) ? 1 : 0;
    const v1f = ((vragen[15].antwoord!) >= 2) ? 1 : 0;
    const v1g = ((vragen[17].antwoord!) >= 2) ? 1 : 0;
    const v1h = ((vragen[19].antwoord!) >= 2) ? 1 : 0;
    const v1i = ((vragen[21].antwoord!) >= 2) ? 1 : 0;
    const aandacht = v1a + v1b + v1c + v1d + v1e + v1f + v1g + v1h + v1i;

    const v2a = ((vragen[1].antwoord!) >= 2 || (vragen[3].antwoord!) >= 2) ? 1 : 0;
    const v2b = ((vragen[5].antwoord!) >= 2) ? 1 : 0;
    const v2c = ((vragen[7].antwoord!) >= 2 || (vragen[8].antwoord!) >= 2) ? 1 : 0;
    const v2d = ((vragen[11].antwoord!) >= 2 || (vragen[12].antwoord!) >= 2) ? 1 : 0;
    const v2e = ((vragen[14].antwoord!) >= 2) ? 1 : 0;
    const v2f = ((vragen[16].antwoord!) >= 2) ? 1 : 0;
    const v2g = ((vragen[18].antwoord!) >= 2) ? 1 : 0;
    const v2h = ((vragen[20].antwoord!) >= 2) ? 1 : 0;
    const v2i = ((vragen[22].antwoord!) >= 2) ? 1 : 0;
    const hyper = v2a + v2b + v2c + v2d + v2e + v2f + v2g + v2h + v2i;

    return (
        <div className="resultaten">
            <h2>Resultaten</h2>

            <div className="thermometers">
                <Thermometer
                    label="Aandachtstekort"
                    score={aandacht}
                    maxScore={9}
                />
                <Thermometer
                    label="Hyperactiviteit/Impulsiviteit"
                    score={hyper}
                    maxScore={9}
                />
            </div>

            <div className="button-row">
                <button
                    className="nav-button toggle-button"
                    onClick={() => setToonVragen(!toonVragen)}
                >
                    {toonVragen ? "Verberg" : "Toon"} gedetailleerde antwoorden
                </button>
                <button className="nav-button" onClick={onTerugNaarVragen}>Terug naar vragen</button>
            </div>

            {toonVragen && (
                <div className="vragen-details">
                    {vragen.map((vraag, index) => {
                        return (
                            <div key={index} className="vraag-detail">
                                <span className="vraag-tekst">{vraag.vraagstelling}</span>
                                <strong className="vraag-score">{scoreLabels[vraag.antwoord!]}</strong>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};
